// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ou2gc","top":"styles_top__PC0qM"};